import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { GeoAreaMslMonitoringKpi } from 'src/app/assabil-sales/models/dtos/geo-area-msl-monitoring-kpi';
import { ItineraryTypeMslMonitoringKpi } from 'src/app/assabil-sales/models/dtos/itinerary-type-msl-monitoring-kpi';
import { MslMonitoringKpi } from 'src/app/assabil-sales/models/dtos/msl-monitoring-kpi';

@Component({
  selector: 'geo-area-msl-monitoring-kpi',
  templateUrl: './geo-area-msl-monitoring-kpi.component.html',
  styleUrls: ['./geo-area-msl-monitoring-kpi.component.scss']
})
export class GeoAreaMslMonitoringKpiComponent implements OnInit {


  @Input() geoAreaMslMonitoringKpi : GeoAreaMslMonitoringKpi;

  @Output() onClick        = new EventEmitter<any>();
  @Input() previousPeriod : string;

  
  constructor() { }

  ngOnInit() {
  }


  clickTitle() {

  } 
  
  click(event : any){
    this.onClick.emit(event);
  }

  clicked(){
    this.geoAreaMslMonitoringKpi.expanded = !this.geoAreaMslMonitoringKpi.expanded;
  }
}